import { gql } from '@apollo/client';
import { NOTIFICATION_FRAGMENT } from '@features/Notification/api/getMyNotifications';

const NOTIFICATIONS_SUBSCRIPTION = gql`
  subscription Notifications($workspaceId: ID!) {
    notifications(workspaceId: $workspaceId) {
      ...Notification
    }
  }
  ${NOTIFICATION_FRAGMENT}
`;

export default NOTIFICATIONS_SUBSCRIPTION;
